import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';
import { SIZES } from '../../../../constants/constants';
import { getLabel } from '../../../../utils/multiSelectUtils';
import { CHIP_DATA_ATTRIBUTE } from '../../constants';
import type { MultiSelectChipItemProps } from '../../types';
import { getChipItemSx, getVisibleChipSx } from '../utils';

export function MultiSelectChipsVisibleListItem({
    value,
    index,
    getTagProps,
    onRemove,
    readOnly = false,
    allValuesVisible,
    isHidden
}: MultiSelectChipItemProps) {
    const tagProps = getTagProps ? getTagProps({ index }) : {};
    const label = getLabel(value);
    const itemSx = getChipItemSx(allValuesVisible, isHidden);
    const chipSx = getVisibleChipSx(readOnly);
    const onDelete = readOnly || !onRemove ? undefined : () => onRemove(value);

    return (
        <Box {...{ [CHIP_DATA_ATTRIBUTE]: true }} sx={itemSx}>
            <Tooltip title={label}>
                <Chip
                    {...tagProps}
                    sx={chipSx}
                    size={SIZES.small}
                    color="default"
                    label={label}
                    variant="filled"
                    onDelete={onDelete}
                />
            </Tooltip>
        </Box>
    );
}
